import { useI18n } from '@affine/i18n';
import type { FC } from 'react';

import { EnumSelect } from '../controls/enum-select';
import { NAV_OPTIONS } from './option-constants';
import type { SectionProps } from './types';

export const NavigationSection: FC<SectionProps> = ({ row, setField }) => {
  const t = useI18n();
  return (
    <EnumSelect
      label={t['com.streamlain.customApps.viewConfig.nav.label']()}
      data-sl-field="nav"
      value={row.nav}
      options={NAV_OPTIONS}
      onChange={v => setField('nav', v)}
    />
  );
};
